import Header from "./common/header"
import HeaderCart from "./common/headerCart";
import LoadPurchase from "./common/loadPurchase";
import Webforms from "./common/webforms";
import Newsletter from "./components/newsletter";
import { quickBuy } from "./components/utilities";

// ==========================================
// Inicialização
// ==========================================
console.log(
  '%cOlist - Soluções de vendas online e Serviços de E-commerce',
  'color: #0a4ee4; font-size: 14px; font-family: "Verdana", sans-serif; font-weight: bold;'
);

window.addEventListener('DOMContentLoaded', () => {
  Header.init()
  HeaderCart.init();
  Newsletter.init();
  Webforms.init();
  LoadPurchase.init();
  quickBuy();
})
